import { render, staticRenderFns } from "./ScoreSelectorV3.vue?vue&type=template&id=692387b0&scoped=true&"
import script from "./ScoreSelectorV3.vue?vue&type=script&lang=ts&"
export * from "./ScoreSelectorV3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692387b0",
  null
  
)

export default component.exports